import { defineMigrations } from "@supersig/store";
/** @public */ export const iconNodeProps = {};
/** @internal */ export const iconNodeMigrations = defineMigrations({});
export const IconNodeInfo = {
    migrations: iconNodeMigrations,
    props: iconNodeProps,
    meta: {}
};
